import { axios } from '@/utils/http'

export async function get() {
  const { data } = await axios.get(`session/right`)
  return data as string[]
}
